<template>
    <iframe :src="iframeSource" frameborder="0"></iframe>
</template>

<script>
  import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";
  import router from '@wl-vue-utils/router.js'

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
    router: router,
    computed: {
        iframeSource() {
            let modelIframe = this.model.iframe || {};
            return modelIframe.url;
        }
    },
    name: "IframeDlMap",

      mounted() {

           window.addEventListener("message", (event) => {
               console.log("IframeDlMap :: Catch event id: ", event.data.eventId);

               if (!!window.dataLayer &&
                   event.data.eventId === "Storelocator:gtm" &&
                   event.data.eventAction !== "" &&
                   event.data.eventLabel !== "") {

                  let dataTracking  = {
                      event: "GAevent",
                      eventCategory : event.data.eventCategory,
                      eventAction: event.data.eventAction,
                      eventLabel: event.data.eventLabel
                  };

                  window.dataLayer.push(dataTracking);
               }
               if (event.data.eventId === "Storelocator:changeFilters") {
                   console.log(`event.data.eventContent ${event.data.eventContent}`);
               }

                if (event.data.eventId === "Storelocator:changeFilters" && event.data.eventContent !== "") {
                    console.log(event.data.eventContent);
                    let searchParams = new URLSearchParams(this.$route.query);
                    searchParams.set('f', event.data.eventContent)
                    const newQuery = Object.fromEntries(searchParams.entries());
                    const encodedQuery = {};
                    for (let key in newQuery) {
                        if (newQuery.hasOwnProperty(key)) {
                            encodedQuery[key] = encodeURIComponent(newQuery[key]);
                        }
                    }
                    console.log("IframeDlMap :: Change url f param", JSON.stringify(encodedQuery));

                    if (JSON.stringify(this.$route.query) !== JSON.stringify(encodedQuery)) {
                        this.$router.replace({ query: encodedQuery })
                            .catch(err => {
                                if (err.name !== "NavigationDuplicated") {
                                console.error(err);
                            }
                        });
                    }
                }
          });

      }
  }
</script>

<style scoped>
    iframe {
        min-width: 100%;
        min-height: calc(100vh - 70px);
    }
</style>
